import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index/index.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TechmoreSharedModule } from '@techmore/share';
import { TmWowModule } from '@techmore/wow';
import { ShareModule } from '../../../../../share/share.module';
import { ShareIndexSectionModule } from '../../../share-index-section.module';



@NgModule({
  declarations: [IndexComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule.forChild(),
    ShareModule,
    TechmoreSharedModule,
    ShareIndexSectionModule,
    TmWowModule,
    FormsModule,
  ],
  entryComponents: [IndexComponent]
})
export class IndexArticle02Module {
  static entry = IndexComponent;
}
